var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import copy from 'clipboard-copy';
import { notify, notifyError } from '@/helpers/action';
/**
 * リンクをコピーする
 * @description クリップボードにリンクをコピーして、完了のトーストを表示する
 * @param copyText コピーするテキスト
 * @param successText 成功時のトーストメッセージ
 * @param errorText エラー時のトーストメッセージ
 */
export const copyLinkAfterToast = (copyText, successText, errorText) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        yield copy(copyText);
        notify(successText || 'リンクをコピーしました');
    }
    catch (e) {
        notifyError(errorText || 'リンクのコピーに失敗しました');
    }
});
